(function () {
  var page_header_slider_v1 = new Swiper(".js_recipe_slider_v1", {
    spaceBetween: 40,
    slidesPerView: 1,
    loop: true,
    // Responsive breakpoints
    breakpoints: {
      // when window width is >= 768px
      767: {
        slidesPerView: 2,
        spaceBetween: 20
      },
      // when window width is >= 992px
      991: {
        slidesPerView: 3,
        spaceBetween: 40
      }
    },
    pagination: {
      el: ".js_recipe_slider_v1_pagination .swiper-pagination",
      clickable: true,
      // dynamicBullets: true,
    },
    navigation: {
      nextEl: ".js_recipe_slider_v1_nav .swiper-button-next",
      prevEl: ".js_recipe_slider_v1_nav .swiper-button-prev",
    },
  });
})();
